module.exports = __webpack_public_path__ + "static/media/listing-page-kasauli.98b14bbd.jpg";